import { Play } from 'lucide-react';

const VideoCard = ({ thumbnail, videoUrl }) => (
  <a
    href={videoUrl}
    target="_blank"
    rel="noopener noreferrer"
    className="relative w-full h-[200px] sm:h-[248px] rounded-xl overflow-hidden bg-[#020617] bg-cover bg-center flex items-center justify-center"
    style={thumbnail ? { backgroundImage: `url(${thumbnail})` } : undefined}
  >
    <div className="absolute inset-0 bg-black/40" />
    <span className="relative z-10 w-10 h-10 rounded-full bg-white/20 flex items-center justify-center">
      <Play size={18} className="text-white fill-white ml-0.5" />
    </span>
  </a>
);

export default VideoCard;
